import { render } from "./MainCourseIndex.vue?vue&type=template&id=5c1f70b2"
import script from "./MainCourseIndex.vue?vue&type=script&lang=js"
export * from "./MainCourseIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__